import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { UtilitiesService } from '@services/utilities.service';

@Directive({
  selector: '[appNumberInputQtyLegacy]',
})
export class NumberInputQtyLegacyDirective {
  @Input('appNumberInputQtyLegacy') separator = '.';

  constructor(private el: ElementRef, private utils: UtilitiesService) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputValue = this.el.nativeElement.value;
    this.el.nativeElement.value = this.formatNumber(inputValue);
  }

  formatNumber(value: string) {
    // Remove non-numeric characters
    // except comma for decimal point
    const numericValue = value.replace(/[^\d,]/g, '');

    // Split value into integer part and decimal part
    const parts = numericValue.split(',');
    let integerPart = parts[0];
    const decimalPart = parts.length > 1 ? ',' + parts[1] : '';

    // Format the integer part
    if (integerPart.length > 3) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // Combine integer and decimal parts
    return integerPart + decimalPart;
  }
}
